import { useEffect, useState } from 'react';
import { Card, Badge, Button, Typography, Row, Col, Modal } from "antd";
import { FolderOutlined, FolderOpenOutlined, EditOutlined } from "@ant-design/icons";
import { fetchPoaData } from '../../services/poa/get_poa';
import FileManagerPOA from '../Poa/FileManagerPOA';

const { Paragraph, Text } = Typography;

export default function CarpetasView({ carpetas, onEdit, onRefresh, onNavigate, isLoading, proyecto, permissionUpdate, estadoIniciar, avanceInfraestructura }) {

    const [itemParams, setItemParams] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    useEffect(() => {
        if (!estadoIniciar) return;

        // Nivel normal
        if (avanceInfraestructura === 1) {
            const enlaceArray = ["2.1.4", "2"];
            procesarMpoa(`{ "${enlaceArray[0]}", "${enlaceArray[1]}" }`);
        }

        // Nivel formato verificación
        if (avanceInfraestructura === 2) {
            const carpeta = {
                oid: 5,
                nombre: "3. Formatos entrega infraestructura",
                tipo: "carpeta",
                enlace: "",
                linkeado: 2,
                subcarpetas: [],
            };
            const tareaEncontrada = { ...carpeta };
            tareaEncontrada.proyectoNoLinkeado = proyecto;
            tareaEncontrada.rutaActividad = "Infraestructura";

            setItemParams(tareaEncontrada);
            setOpenModal(true);
        }
    }, [estadoIniciar, avanceInfraestructura]);


    const extraerPrimerValorDeEnlace = (enlaceStr, opcion) => {
        if (!enlaceStr) return null;
        const limpio = enlaceStr.replace(/[{}"]/g, "").trim();
        const partes = limpio.split(",").map(s => s.trim());
        return partes[opcion] || null;
    };


    const procesarMpoa = async (enlaceStr) => {
        const Mpoa = extraerPrimerValorDeEnlace(enlaceStr, 0);
        if (Mpoa) {
            if (Mpoa === '2.2.1') {
                return null;
            }
            const manejarActividadEspecial = (actividad) => {
                switch (actividad) {
                    case '2.2.1.1':
                        return '2.2.1';
                    case '2.2.1.2':
                        return '2.2.1';
                    case '2.2.1.3':
                        return '2.2.1';
                    case '2.3.1.1':
                        return '2.3.1';
                    case '2.3.1.2':
                        return '2.3.1';
                    case '2.3.1.3':
                        return '2.3.1';
                    default:
                        return actividad;
                }
            };
            const actividadBase = manejarActividadEspecial(Mpoa);
            try {
                const dataCompleta = await fetchPoaData();
                const dataPoa = dataCompleta.dataPoa;
                const findNodePath = (node, path = []) => {
                    path.push(node);
                    if (node.codigo_tarea === actividadBase && !['2.2.1.2', '2.2.1.3', '2.3.1.1', '2.3.1.2', '2.3.1.3'].includes(Mpoa)) {
                        return path;
                    }
                    if (['2.2.1.2', '2.2.1.3', '2.3.1.1', '2.3.1.2', '2.3.1.3'].includes(Mpoa)) {
                        if (node.children && node.children.length > 0) {
                            for (let child of node.children) {
                                if (Mpoa === '2.2.1.2' && child.key === 'indicador_33') {
                                    path.push(child);
                                    return path;
                                }
                                if (Mpoa === '2.2.1.3' && child.key === 'indicador_34') {
                                    path.push(child);
                                    return path;
                                } if (Mpoa === '2.3.1.1' && child.key === 'indicador_38') {
                                    path.push(child);
                                    return path;
                                }
                                if (Mpoa === '2.3.1.2' && child.key === 'indicador_39') {
                                    path.push(child);
                                    return path;
                                }
                                if (Mpoa === '2.3.1.3' && child.key === 'indicador_40') {
                                    path.push(child);
                                    return path;
                                }
                            }
                        }
                    }

                    if (node.children && node.children.length > 0) {
                        for (let child of node.children) {
                            const result = findNodePath(child, [...path]);
                            if (result) return result;
                        }
                    }
                    return null;
                };
                let matchedPath = null;
                for (let nodo of dataPoa) {
                    matchedPath = findNodePath(nodo);
                    if (matchedPath) break;
                }
                if (matchedPath) {
                    const initialData = extractData(matchedPath);
                    const actividadData = initialData[0].actividadData;
                    const tareaEncontrada = actividadData.find((item) => {
                        if (['2.2.1.2', '2.2.1.3', '2.3.1.1', '2.3.1.2', '2.3.1.3'].includes(Mpoa)) {
                            return (
                                item.codigo_tarea === actividadBase &&
                                ((Mpoa === '2.2.1.2' && item.key === 'indicador_33') ||
                                    (Mpoa === '2.2.1.3' && item.key === 'indicador_34') || (Mpoa === '2.3.1.1' && item.key === 'indicador_38') || (Mpoa === '2.3.1.2' && item.key === 'indicador_39') || (Mpoa === '2.3.1.3' && item.key === 'indicador_40'))
                            );
                        }
                        return item.codigo_tarea === actividadBase;
                    });

                    if (tareaEncontrada) {
                        try {
                            const informe = extraerPrimerValorDeEnlace(enlaceStr, 1);
                            if (informe !== "2") {
                                tareaEncontrada.informeVisitas = "tarea_414/indicador_73/medio_verificacion_68/Informe 12/Soportes Infraestructura_30 jun/Implementación/FAO/" + proyecto;
                            } else {
                                tareaEncontrada.proyecto25 = proyecto;
                            }
                            setItemParams(tareaEncontrada);
                            setOpenModal(true);
                        } catch (error) {
                            console.error("Error al obtener dataInfraestructura:", error);
                            setItemParams(null);
                            setOpenModal(false);
                        }
                    }

                } else {
                    console.warn("No se encontró ningún nodo coincidente");
                }
            } catch (error) {
                console.error("Error al obtener los datos:", error);
            }

        };
    }

    const extractData = (children) => {
        return children.flatMap(child => {
            if (child.children && child.tipo === 'Actividad') {
                const actividadData = child.children.flatMap(grandchild => {
                    if (grandchild.children && grandchild.tipo === 'Tarea') {
                        return grandchild.children.flatMap(greatGrandchild => {
                            if (greatGrandchild.tipo === 'Indicador') {
                                const fecha = greatGrandchild.meta_e?.[0]?.fecha;
                                const fechaFormateada = fecha ? new Date(fecha).toLocaleDateString('es-ES') : '-';
                                const metaProyectada = greatGrandchild.meta_proyectada || 0;
                                const valorEjecutado = Math.floor((greatGrandchild.meta_e?.reduce((total, meta) => total + meta.valor, 0) || 0) * 100) / 100;
                                const porcentajeEjecucion = metaProyectada > 0 ? (valorEjecutado / metaProyectada) * 100 : 0;
                                const medioV = greatGrandchild.medioVerificacion || null;
                                return {
                                    key: greatGrandchild.key,
                                    codigo_tarea: grandchild.codigo_tarea,
                                    codActividad: grandchild.codActividad,
                                    nameActividad: child.actividad,
                                    tarea: grandchild.tarea,
                                    indicador: greatGrandchild.title,
                                    medioV: medioV,
                                    meta_proyectada: metaProyectada,
                                    valorEjecutado: valorEjecutado,
                                    porcentaje_ejecucion: porcentajeEjecucion % 1 === 0 ? porcentajeEjecucion.toFixed(0) : porcentajeEjecucion.toFixed(1),
                                    porcentaje_avance: greatGrandchild.meta_e?.[0]?.valor || 'N/A',
                                    fechas: fechaFormateada,
                                    responsables: 'N/A',
                                    soportes: 'N/A',
                                    datoIndicador: greatGrandchild,
                                };
                            }
                            return [];
                        });
                    }
                    return [];
                });
                const totalMetaProyectada = actividadData.reduce((total, data) => total + (data.meta_proyectada || 0), 0);
                const totalValorEjecutado = actividadData.reduce((total, data) => total + (data.meta_proyectada * (parseFloat(data.porcentaje_ejecucion) / 100) || 0), 0);
                const porcentajeEjecucionActividad = totalMetaProyectada > 0 ? (totalValorEjecutado / totalMetaProyectada) * 100 : 0;
                return [{
                    actividadTitle: child.title,
                    actividad: child.actividad,
                    porcentajeEjecucionActividad: porcentajeEjecucionActividad.toFixed(1),
                    actividadData: actividadData
                }];
            }
            return [];
        });
    };

    const handleCardClick = (carpeta, event) => {
        if (event.target.closest("button")) return;
        if ((carpeta.subcarpetas?.length > 0 && carpeta.tipo === "carpeta")) {
            onNavigate(carpeta);
        } else if (carpeta.enlace && carpeta.linkeado === 1) {
            procesarMpoa(carpeta.enlace);
        } else if (!carpeta.enlace && carpeta.linkeado === 2) {
            const tareaEncontrada = { ...carpeta };
            tareaEncontrada.proyectoNoLinkeado = proyecto;
            tareaEncontrada.rutaActividad = "Infraestructura";
            setItemParams(tareaEncontrada);
            setOpenModal(true);
        }
    };

    if (isLoading) {
        return (
            <Row gutter={[16, 16]}>
                {[...Array(6)].map((_, i) => (
                    <Col xs={24} sm={12} md={8} lg={6} key={i}>
                        <Card loading />
                    </Col>
                ))}
            </Row>
        );
    }
    if (carpetas.length === 0) {
        return (
            <div style={{ textAlign: "center", padding: "50px 0" }}>
                <FolderOutlined style={{ fontSize: "48px", color: "#d9d9d9" }} />
                <Paragraph>No hay carpetas disponibles.</Paragraph>
                <Text type="secondary">Crea tu primera carpeta para comenzar.</Text>
            </div>
        );
    }

    const hideModalMedios = () => {
        setOpenModal(false);
    };

    const handleCloseDrawer = () => {
        hideModalMedios(false);
        setItemParams(null);
    };

    return (
        <>
            <Row gutter={[16, 16]}>
                {carpetas.map((carpeta, index) => (
                    <Col key={carpeta.id || `carpeta-${index}`} xs={24} sm={12} md={8} lg={8}>
                        <Card
                            hoverable
                            onClick={(e) => handleCardClick(carpeta, e)}
                            style={{ borderRadius: 8, padding: 20, height: "100%", justifyContent: "space-between", border: "1px solid #85C3D0" }}
                        >
                            <Card.Meta
                                avatar={
                                    carpeta.tipo === "carpeta" ? (
                                        <FolderOutlined style={{ color: "#1890ff", fontSize: 28 }} />
                                    ) : (
                                        <FolderOpenOutlined style={{ color: "#fa8c16", fontSize: 28 }} />
                                    )
                                }
                                title={
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <Text ellipsis style={{ fontSize: 16 }}>{carpeta.nombre}</Text>
                                        <Badge
                                            count={carpeta.tipo}
                                            style={{
                                                fontSize: 12, backgroundColor: carpeta.tipo === "carpeta" ? "#108ee9" : "#999",
                                            }}
                                        />
                                    </div>
                                }
                                description={
                                    <>
                                        {(carpeta.subcarpetas?.length || 0) > 0 && (
                                            <Text type="warning">
                                                {carpeta.subcarpetas.length} elemento(s)
                                            </Text>
                                        )}
                                    </>
                                }
                            />
                            <div style={{ marginTop: 12 }}>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        gap: 8,
                                        padding: 18,
                                    }}
                                >
                                    {(permissionUpdate &&
                                        <Button
                                            style={{
                                                borderRadius: 8,
                                                padding: 12,
                                                fontSize: 14,
                                            }}
                                            size="small"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onEdit(carpeta);
                                            }}
                                            icon={<EditOutlined style={{ fontSize: 16 }} />}
                                        >
                                            Editar
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
            <div className="d-flex justify-content-center">
                <Modal
                    title={<span className="custom-modal-title">Medios de verificación</span>}
                    open={openModal}
                    onCancel={hideModalMedios}
                    destroyOnHidden={true}
                    footer={null}
                    width="95%"
                    style={{ top: 20 }}
                >
                    <FileManagerPOA codigo_tarea={{ codigo_tarea: itemParams }} onClose={handleCloseDrawer} />
                </Modal>
            </div>
        </>
    );
}

